import React from 'react'
import './chartBarLegends.less'
import { Button } from '@lightbeamai/design-system'
import classNames from 'classnames'

type LegendConfig = {
  color: string
  title: string
}

interface IProps {
  legendsData?: LegendConfig[]
  linkTitle?: string
  compactLegend?: boolean
  linkHandler?: () => void
}

const ChartBarLegends: React.FC<IProps> = ({
  legendsData,
  linkTitle,
  linkHandler,
  compactLegend
}) => {
  const hasLinkDataComponent = !!linkTitle && !!linkHandler && legendsData?.length

  return (
    <div
      className={classNames('chart-bar-label-info', {
        'with-link': hasLinkDataComponent
      })}
    >
      {!!linkTitle && !!linkHandler && (
        <div
          className={classNames('', {
            'link-component': hasLinkDataComponent,
            'link-component-compact': compactLegend
          })}
        >
          <Button variant="link" onClick={linkHandler}>
            {linkTitle}
          </Button>
        </div>
      )}
      {legendsData && legendsData?.length > 0 && (
        <div
          className={classNames('label-container', {
            'label-container-compact': compactLegend
          })}
        >
          {legendsData?.map((legend) => (
            <div className="label" key={legend.title}>
              <div className="color" style={{ backgroundColor: legend.color }} />
              <div className="text">{legend.title}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

export default ChartBarLegends
